import React from "react";
import { FOOTER } from "../../../layout/eng/footer";
import { SUBHEADER } from "../../../layout/eng/subheader";
import { EN_Ideology } from "../../../parts/eng/intro/ideology";
import { Helmet } from "react-helmet";
export const EN_IDEOLOGY = () => {
  return (
    <main id="content">
      <SUBHEADER />
      <div id="intro">
        <EN_Ideology />
      </div>
      <FOOTER />
    </main>
  );
};
